import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import AnalyticsPdfLinkRow from './AnalyticsPdfLinkRow'
import styles from './AnalyticsPdfLinkDetails.module.css'

const ANALYTICS_PDF_LINK_HEADERS = [
  { label: 'Link URL', colProps: { lg: 8 } },
  { label: 'Clicks', colProps: { lg: 4 } }
]

const AnalyticsPdfLinkDetailsTable = ({ linkAnalytics }) => (
  <Card>
    <Card.Body>
      <h5 className="mb-3">Link-by-Link Analytics</h5>
      <p className="d-lg-none text-muted small mb-3">Clicks recorded for links within the PDF</p>
      <div className={styles.linkDetailsTable}>
        <Row className="fw-bold d-none d-lg-flex pb-3 border-bottom g-0">
          {ANALYTICS_PDF_LINK_HEADERS.map((header) => (
            <Col key={header.label} {...header.colProps}>
              {header.label}
            </Col>
          ))}
        </Row>

        {linkAnalytics.length > 0 ? (
          linkAnalytics.map((link) => <AnalyticsPdfLinkRow key={link.url} link={link} />)
        ) : (
          <p className="text-muted text-center mt-4">No link click data available</p>
        )}
      </div>
    </Card.Body>
  </Card>
)

export default AnalyticsPdfLinkDetailsTable
